import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	displayText: {
		id: 'backlog.header.menu.create-board.display-text',
		defaultMessage: 'Create board',
		description: 'Dropdown menu item which open the "Create board" feature',
	},
});
